import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

export default {
    components: { ECharts },
    computed: {
        initOptions() {
            return {
                renderer: 'canvas',
            }
        },
    },
}
